import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Promotion", -1)
const _hoisted_6 = { class: "card-footer bg-white border border-light" }
const _hoisted_7 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Promotion Booster Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", null, [
              _createVNode(_component_router_link, {
                to: _ctx.model.promotionLink
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.model.promotionName), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ]),
      _createVNode(_component_app_table, {
        columns: _ctx.table.columns,
        rows: _ctx.model.boosters,
        total: _ctx.model.boosters.length
      }, null, 8, ["columns", "rows", "total"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_app_button, {
            name: "Edit",
            theme: "info",
            icon: "fa-edit",
            to: { name: _ctx.ROUTE_NAME_PROMOTION.BOOSTER.EDIT, params: { id: _ctx.model.id } }
          }, null, 8, ["to"])
        ])
      ])
    ]),
    _: 1
  }))
}